<template>
  <el-container>
    <el-header>
      <TopMenu />
    </el-header>
    <el-container>
      <router-view></router-view>
    </el-container>
  </el-container>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import TopMenu from "../topmenu/TopMenu.vue";

export default {
  name: "index",
  components: {
    TopMenu,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style>
.el-container {
  background-color: rgb(247, 248, 252);
  height: 100vh;
  width: 100vw;
  overflow-x: auto;
  /* overflow: -moz-scrollbars-none;
  -ms-overflow-style: none; */
}
/* 针对Chrome, Safari和Opera */
/* ::-webkit-scrollbar {
  display: none;
} */
.el-header {
  background-color: white;
  color: #333;
  /* line-height: 100px; */
  /* text-align: right; */
  /* padding-top: 1vh; */
  font-size: 12px;
  vertical-align: bottom;
  text-align: left;
  /* display: flex;
    flex-direction: column;
    justify-content: flex-end; */
}
.el-main {
  height: 89vh;
  margin-top: 1.5vh;
  background-color: white;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
  border-radius: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue